import React from "react";
import { EvtHeader } from "components/header";
import MeetingForm from "../form";
import { useParams } from "react-router-dom";

export default function UpdateMeeting() {
  const { meetingId } = useParams();
  return (
    <div className="flex-1">
      <EvtHeader title="Edit Meeting" />
      <div className="max-w-md p-4 lg:p-6">
        <MeetingForm meetingId={meetingId} />
      </div>
    </div>
  );
};
